import { Box, Skeleton, Tab, Tabs, Typography } from '@mui/material';

import NonIdealState from 'src/components/shared/NonIdealState';

interface InputTabsRailProps {
  tabs: { key: string; label: string }[];
  selected: string | null;
  onSelect: (key: string) => void;
  /** The tab list is still on its way, so an empty list is not yet an answer. */
  loading?: boolean;
}

const SKELETON_TAB_COUNT = 3;

export const InputTabsRail = ({
  tabs,
  selected,
  onSelect,
  loading = false,
}: InputTabsRailProps) => {
  if (tabs.length === 0 && loading) {
    return (
      <Box
        role="status"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          px: 2,
          py: 1.5,
          borderBottom: 1,
          borderColor: 'divider',
        }}
      >
        <Typography variant="body2" color="text.secondary">
          Loading Conflicts...
        </Typography>
        {Array.from({ length: SKELETON_TAB_COUNT }, (_, i) => (
          <Skeleton key={i} variant="rounded" width={140} height={24} />
        ))}
      </Box>
    );
  }

  if (tabs.length === 0) {
    return <NonIdealState title="No conflicts in this section" height={20} />;
  }

  return (
    <Tabs
      variant="scrollable"
      aria-label="Inputs with conflicts"
      value={selected ?? false}
      onChange={(_e, value: string) => onSelect(value)}
      sx={{ borderBottom: 1, borderColor: 'divider' }}
    >
      {tabs.map((t) => (
        <Tab key={t.key} value={t.key} label={t.label} />
      ))}
    </Tabs>
  );
};

export default InputTabsRail;
